import {CustomComponentContext, CustomComponentContextType} from '@/utils/contexts/CustomComponentContext';
import React, {useContext, useEffect, useState} from 'react';
import {Controller} from 'react-hook-form';
import {Input} from "alurkerja-ui";

export default function InputAlasanTerlambat() {
  const { setValue, control, watch } = useContext<CustomComponentContextType>(CustomComponentContext);
  const classNamesLabel = "after:content-['*'] after:text-red-400 after:text-sm font-medium";
  const [isLate, setIsLate] = useState(false);

  useEffect(() => {
    const currentTime = new Date();
    const currentHour = currentTime.getHours();
    const currentMinutes = currentTime.getMinutes();
    if (currentHour > 9 || (currentHour === 9 && currentMinutes > 5)) {
      setIsLate(true);
    } else {
      setIsLate(false);
    }
    setValue('reason_late', '');
  }, [setValue]);

  if (isLate) {
    return (
      <div className="flex flex-col gap-4">
        <div>
          <label className={classNamesLabel}>Alasan Terlambat</label>
          <Controller
            name={'reason_late'}
            control={control}
            rules={{ required: { value: true, message: `Alasan Terlambat is Required.` } }}
            render={({ fieldState }) => {
              return (
                <>
                  <Input
                    onChange={e => setValue('reason_late', e.target.value)}
                    textArea
                  />
                  {fieldState.error && <p className="text-sm text-red-500">{fieldState.error.message}</p>}
                </>
              );
            }}
          ></Controller>
        </div>
      </div>
    );
  }

  return null;
}